import { Group, Image, Text } from "@mantine/core";
import { SimCardOperator } from "@/models/club";
import hamrahAval from "@/assets/images/hamrah_aval.png";
import irancell from "@/assets/images/irancelLogo.png";

export default function OperatorLabel({ operator }: { operator: SimCardOperator }) {
  const isIrancell = operator === SimCardOperator.Value2;
  return <Group gap="sm" wrap="nowrap">
    <Image src={isIrancell ? irancell : hamrahAval} alt="" w={48} h={34} fit="contain" />
    <Text size="sm" component="span">{isIrancell ? "ایرانسل" : "همراه اول"}</Text>
  </Group>;
}
